import './social-login.scss';
import { useEffect, useState } from 'react';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';

export const GoogleLogin = ({ redirect }: { redirect?: string }) => {
  const { getOauthConfig } = useAPI();
  const [googleOauthUrl, setGoogleOauthUrl] = useState<string | null>(null);
  useEffect(() => {
    getOauthConfig('google', redirect).then((resp) => {
      setGoogleOauthUrl(resp.url);
    });
  }, []);
  return (
    <>
      {googleOauthUrl && (
        <>
          <a href={googleOauthUrl} className={'facebook_btn mb-8'}>
            <i className={'fa-brands fa-google fa-xl'}></i>
            <span style={{ paddingLeft: '10px' }}> Continue with Google</span>
          </a>
        </>
      )}
    </>
  );
};
